<div class="error-container" role="main">
  <div class="error-content">
    <h1 class="error-code" tabindex="0" [attr.aria-label]="'PAGE_NOT_FOUND.TITLE' | translate">
      404
    </h1>
    <h2 class="error-title" tabindex="0">
      {{ 'PAGE_NOT_FOUND.TITLE' | translate }}
    </h2>
    <p class="error-message" tabindex="0">
      {{ 'PAGE_NOT_FOUND.MESSAGE' | translate }}
    </p>
    
    <div class="action-box">
      <button 
        class="btn-home"
        routerLink="/" 
        [attr.aria-label]="'PAGE_NOT_FOUND.BACK_HOME' | translate"
      >
        <i class="fas fa-home"></i> {{ 'PAGE_NOT_FOUND.BACK_HOME' | translate }}
      </button>
    </div>
  </div>
</div>